import { Typography } from '@/shared/ui';
import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './AlbumOrientation.module.scss';
import GameIcon from '/public/images/splash-screen/gameIcon.png';

const AlbumOrientation: React.FC = () => {
	const { t } = useTranslation('translation', { keyPrefix: 'albumOrientation' });
	const [isLandscape, setIsLandscape] = useState(false);

	const [isMobile] = useState(/Android|iPhone|iPad|iPod|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent));

	const checkOrientation = () => {
		const width = window.innerWidth;
		const height = window.innerHeight;
		const viewportHeight = window.visualViewport?.height ?? height;

		if (isMobile) {
			const isLandscapeByScreen = window.screen.orientation?.type?.startsWith('landscape') ?? false;
			const isLandscapeByRatio = width > height;
			const isLikelyKeyboardOpen = viewportHeight / height < 0.7;

			if (isLikelyKeyboardOpen) {
				setIsLandscape(false);
			} else {
				setIsLandscape(isLandscapeByScreen || isLandscapeByRatio);
			}
		} else {
			setIsLandscape(width >= 780 || height >= 860);
		}
	};

	useEffect(() => {
		checkOrientation();

		window.addEventListener('resize', checkOrientation);
		globalThis.addEventListener('orientationchange', checkOrientation);
		window.visualViewport?.addEventListener('resize', checkOrientation);

		return () => {
			window.removeEventListener('resize', checkOrientation);
			globalThis.removeEventListener('orientationchange', checkOrientation);
			window.visualViewport?.removeEventListener('resize', checkOrientation);
		};
	}, []);

	return isLandscape ? (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.2 }}
			className={styles.overlay}
		>
			<Typography variant='title1' color='white'>
				{isMobile ? t('header') : t('pc.header')}
			</Typography>
			<Typography variant='footnote' color='white'>
				{isMobile ? t('description') : t('pc.description')}
			</Typography>
			<div className={styles.iconWrapper}>
				<motion.img
					src={GameIcon}
					alt='rotate'
					className={styles.icon}
					initial={{ rotate: 0 }}
					animate={{ rotate: [0, 20, -20, 0] }}
					transition={{ duration: 2, ease: 'easeInOut', repeat: Infinity }}
				/>
			</div>
		</motion.div>
	) : null;
};

export default AlbumOrientation;
